import { render, staticRenderFns } from "./AdminRequestForm.vue?vue&type=template&id=5dbc70de&"
import script from "./AdminRequestForm.vue?vue&type=script&lang=js&"
export * from "./AdminRequestForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports